export default __webpack_public_path__ + "static/media/image17.3be74d63.png";